module.exports = __webpack_public_path__ + "img/bg-top@2x.4da1f19d.jpg";